// Basket content doesn't flow with width, so pin it and let the menu absorb the
// slack. A 25% share left laptops with a 230px basket. Shared with the vendor header
// and both skeletons so every row splits at the same x.
export const BASKET_COLUMN_WIDTH = { md: 320, lg: 360, xl: 400 }
